import { useLocation } from 'react-router-dom'
import queryString from 'query-string'

export const useQuerySearchParams = <T>() => {
  const location = useLocation()
  const searchParams = queryString.parse(location.search)

  return searchParams as T
}
